require('../brokerHireInvestmentFund.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ core
const moment = require("moment");
// @ actions
const investmentFundsWithContributionActions = require('actions/investmentFundsWithContribution');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const { BrokerHireInvestmentFundStep1 } = require('../../brokerHireInvestmentFundStep1/brokerHireInvestmentFundStep1');
const  {BrokerHireInvestmentFundContributionsStep} = require('../../../brokerHireInvestmentFundContributionsStep/brokerHireInvestmentFundContributionsStep');
const { BrokerHireInvestmentFundStep2 } = require('../../brokerHireInvestmentFundStep2/brokerHireInvestmentFundStep2');
const BrokerHireInvestmentFundSuccess = require('../../brokerHireInvestmentFundSuccess/brokerHireInvestmentFundSuccess');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
// @ constants
const { catalogue, analyticsId } = require('../../analytics/brokerHireInvestmentFund.tracking');

class BrokerHireInvestmentFundWithContribution extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    componentDidMount() {
        const { immInvestmentFunds, setCustomMinimumAdditionalPurchaseAmount } = this.props;
        const customMinimumPurchaseAmount = immInvestmentFunds.getIn(['steps', 0, 'customMinimumAdditionalPurchaseAmount']);
        if (customMinimumPurchaseAmount) {
            setCustomMinimumAdditionalPurchaseAmount(customMinimumPurchaseAmount);           
        }
    }

    componentWillReceiveProps(newProps) {
        const { immInvestmentFundsWithContribution, onFinish } = newProps;
        const finished = immInvestmentFundsWithContribution.get('submitSuccessful');
        const visibleStepValid = immInvestmentFundsWithContribution.getIn(['steps', 1, 'valid']);

        if (__CONTACT_CENTER__ && visibleStepValid && !finished) {
            onFinish();
        }
    }

    onCancel() {
        this.props.onCancel();
    }

    onFinish() {
        this.props.onFinish();
    }

    buildWizard() {
        const {
            accountSelected,
            fundId,
            immAccounts,
            immBlockedAccountsIds,
            immBrokerMyInvestments,
            immInvestmentFunds,
            immFlagBasedFeatures,
            isBlockedAccountsLoading,
            validateStep,
            setVisibleStep,
            setWillCancel,
            wizzardTitle,
            immInvestmentFundsWithContribution,
            setAmountContribution,
            setPeriodicityContribution,
            setDateContribution,
            skipContributionStep
        } = this.props;
        const periodicityOptions = immInvestmentFundsWithContribution.getIn(['steps', 1, 'periodicityOptions']);
        const periodicityValue = immInvestmentFundsWithContribution.getIn(['steps', 1, 'periodicityValue']);
        const contributionAmount = immInvestmentFundsWithContribution.getIn(['steps', 1, 'amount']);
        const amountErrorState = immInvestmentFundsWithContribution.getIn(['steps', 1, 'amountErrorState']);
        const amountErrorMsg = immInvestmentFundsWithContribution.getIn(['steps', 1, 'amountErrorMsg']);
        const immSteps = immInvestmentFundsWithContribution.get('steps');
        const customMinimumPurchaseAmount = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'customMinimumPurchaseAmount']);
        const isValidAmount = immInvestmentFundsWithContribution.getIn(['steps', 1, 'valid']);
        const stepsAmount = immSteps.size;
        const visibleStep = immInvestmentFundsWithContribution.get('visibleStep');
        const isFetching = immInvestmentFundsWithContribution.get('isFetching');
        const wizardClass = 'hire-investment__wizard';
        const immFinalButton = 'broker-hireInvestmentSubmit';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: this.onCancel,
            finish: this.onFinish,
        };
        const titleHeaderMenuWizard = visibleStep === 1 ? formatText('breadcrumb-' + wizzardTitle) : formatText('breadcrumb-' + wizzardTitle +'StepTwo');
        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData: []
        };
        const contractNumberSelected = immAccounts.getIn([accountSelected, 'contractNumber']);
        const isin = immInvestmentFundsWithContribution.getIn(['investmentFunds', 'isin']);
        const immFundSelected = immBrokerMyInvestments
            .getIn(['products', 'funds', 'stocks']).filter( fund => fund.get('associatedAccountContractNumber') === contractNumberSelected )
            .find( fundSel => fundSel.get('customInstitutionSecurityId') ===  fundId && fundSel.get('isin') ===  isin)
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;

        const tealiumData = [
            catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW]({ productName: isin, stepNumber: 1 }),
            catalogue[analyticsId.BROKER_HIRE_INVESTMENT_CONTRIBUTION_STEP_VIEW]({ productName: isin, stepNumber: 2 }),
            catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW]({ productName: isin, stepNumber: 3 }),
        ];

        const firstDay = moment().startOf('day');
        const minDate = DateHelper.getNextBussinessDay(false, firstDay);

        const tealiumEventActionByStep = {
            1: 'investmentDetails',
            2: 'investmentDetails2',
            3: 'termsConditions'
        }
        const buttonNextTags = {
            1: 'comprar',
            2: 'withPeriodicContribution',
            3: 'comprar'
        }
        const stepName = tealiumEventActionByStep[visibleStep];
        const productName = immSteps.getIn([0, 'contributionFunds', 'name']);
        const buttonNextTag = buttonNextTags[visibleStep];
        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
                tealium={tealiumData[visibleStep - 1]}
                tealiumEvents={catalogue.footerButtons({stepName, productName, isin, buttonNextTag})}
                isTaggingSecondVersion
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                    isLoading={isFetching}
                    nextButtonDisabled={linkedToRobo}
                >
                    <BrokerHireInvestmentFundStep1
                        immAccounts={this.props.immAccounts}
                        immInvestmentFunds={this.props.immInvestmentFundsWithContribution}
                        immBlockedAccountsIds={immBlockedAccountsIds}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        onChangeContract={this.props.handleChangeContract}
                        accountSelected={accountSelected}
                        onAccountChange={this.props.handleAccountChange}
                        onSetAmount={this.props.handleSetAmount}
                        onReadCheckedStep1={this.props.onReadCheckedStep1}
                        setIntervenerName={this.props.setIntervenerName}
                        setIntervenerType={this.props.setIntervenerType}
                        addIntervener={this.props.addIntervener}
                        removeIntervener={this.props.removeIntervener}
                        restoreDefaultInterveners={this.props.restoreDefaultInterveners}
                        isBlockedAccountsLoading={isBlockedAccountsLoading}
                        setIsSubscription={this.props.setIsSubscription}
                        setIsNewContract={this.props.setIsNewContract}
                        validateSchema={this.props.validateSchema}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        onStepChange={this.props.onStepChange}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    nextButton={true}
                    previousButton={true}
                    nextButtonDisabled={!isValidAmount}
                >
                    <BrokerHireInvestmentFundContributionsStep
                        customMinimumPurchaseAmount={customMinimumPurchaseAmount}
                        amount={contributionAmount}
                        amountErrorState={amountErrorState}
                        amountErrorMsg={amountErrorMsg}
                        setAmount={setAmountContribution}
                        periodicityError={false}
                        periodicityErrorMsg={false}
                        periodicityValue={periodicityValue}
                        periodicityOptions={periodicityOptions}
                        setPeriodicity={setPeriodicityContribution}
                        setValidityDate={setDateContribution}
                        selectedDate={minDate}
                        minDate={minDate}
                        setDatePickerError={()=>console.log("setDatePickerError")}
                        skipContribution={(e) => skipContributionStep(e)}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <BrokerHireInvestmentFundStep2
                        immInvestmentFunds={this.props.immInvestmentFundsWithContribution}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        immAccounts={this.props.immAccounts}
                        fundId={fundId}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        onStepChange={this.props.onStepChange}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildContent() {
        let content;
        if (this.props.immInvestmentFundsWithContribution && !this.props.immInvestmentFundsWithContribution.get('submitSuccessful')) {
            content = this.buildWizard();
        } else {
            content = (
                <BrokerHireInvestmentFundSuccess
                    immSubscription={this.props.immInvestmentFundsWithContribution}
                    immInvestmentFunds={this.props.immInvestmentFundsWithContribution}
                    immAccounts={this.props.immAccounts}
                    immFlagBasedFeatures={this.props.immFlagBasedFeatures}
                    immInvestmentFundsWithContribution={this.props.immInvestmentFundsWithContribution}
                    immBrokerMyInvestments={this.props.immBrokerMyInvestments}
                />
            );
        }

        return content;
    }

    render() {
        return this.buildContent();
    }
}

BrokerHireInvestmentFundWithContribution.propTypes = {
    fundId: PropTypes.string,
    immBlockedAccountsIds: PropTypes.object,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immSteps: PropTypes.object,
    immInvestmentFunds: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    isBlockedAccountsLoading: PropTypes.bool.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,

    onFinish: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    accountSelected: PropTypes.string,
    handleAccountChange: PropTypes.func.isRequired,
    handleSetAmount: PropTypes.func.isRequired,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    onReadCheckedStep1: PropTypes.func.isRequired,
    wizzardTitle: PropTypes.object,
    handleChangeContract: PropTypes.func,
    setIsSubscription: PropTypes.func,
    setIsNewContract: PropTypes.func,
    validateSchema: PropTypes.func,
    extantDataFetch: PropTypes.func,
    onStepChange: PropTypes.func,
};

module.exports.constructor  = BrokerHireInvestmentFundWithContribution;
module.exports.BrokerHireInvestmentFundWithContribution = connect(
    state => ({
        immInvestmentFundsWithContribution: state.investmentFundsWithContribution,
        immInvestmentFunds: state.investmentFunds,
    }), {
    setAmountContribution: investmentFundsWithContributionActions.setAmountContribution,
    setCustomMinimumAdditionalPurchaseAmount: investmentFundsWithContributionActions.setCustomMinimumAdditionalPurchaseAmount,
    setPeriodicityContribution: investmentFundsWithContributionActions.setPeriodicityContribution,
    setDateContribution: investmentFundsWithContributionActions.setDateContribution,
    getBuyFundsDataExtantCosts: investmentFundsWithContributionActions.postExtantCostsBuyFunds,
    onStartOperation: investmentFundsWithContributionActions.operationStarted,
    getSubscriptionDetails: investmentFundsWithContributionActions.getSubscriptionDetails,
    validateStep: investmentFundsWithContributionActions.validateStep,
    setVisibleStep: investmentFundsWithContributionActions.setVisibleStep,
    setAmount: investmentFundsWithContributionActions.setAmount,
    skipContributionStep: investmentFundsWithContributionActions.skipContributionStep,
}
)(withRouter(BrokerHireInvestmentFundWithContribution));
